<template>
  <button 
    type="submit" 
    class="submit-button" 
    :disabled="disabled"
    @click="$emit('click')"
  >
    <span v-if="!disabled" class="button-content">
      <span>{{ text }}</span>
      <i v-if="icon" :class="[icon, 'ms-2']"></i>
    </span>
    <span v-else class="button-content">
      <span class="spinner"></span>
      <span class="ms-2">{{ loadingText }}</span>
    </span>
  </button>
</template>

<script>
export default {
  name: 'SubmitButton',
  props: {
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'fas fa-paper-plane'
    },
    loadingText: {
      type: String,
      default: 'Invio in corso...'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click']
}
</script>

<style scoped>
.submit-button {
  position: relative;
  padding: 16px 48px;
  background: #2a5298;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 16px rgba(42, 82, 152, 0.3);
  overflow: hidden;
  min-width: 200px;
}

.submit-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.submit-button:hover::before {
  left: 100%;
}

.submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  background: #1e3c72;
  box-shadow: 0 8px 24px rgba(42, 82, 152, 0.4);
}

.submit-button:active:not(:disabled) {
  transform: translateY(0);
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.button-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>

